module.exports = __webpack_public_path__ + "img/4.-季节观赏法-冬季-戒台寺卧龙松（杨树田-摄）.3da299f3.jpg";